var _a, _b, _c;
import { createBreakpoints, createColors } from "../theme";
import { BackgroundType } from "../components/Background";
import { sasBrandColor } from "./brandColors";
var leaderboardColors = {
    yellow: "#FFCC33",
    deepYellow: "#D9A30B",
    lightYellow: "#FFE86F"
};
var brandAtInnovateColors = {
    yellow: "#F5C751",
    lightYellow: "#F7D378",
    chatLight: "#C4DEFD",
    chatDark: "#0664D0",
    darkAccent: "#132665",
    dashboardBG: "#033772",
    lightBlue: "#E1EFFE",
};
var TeamInfos = {
    first: {
        name: "yellow",
        main: "#937731",
        lightBG: "#F5C751",
        mediumBG: "#F5C751",
        darkBG: "#F5C751", // Background for Leaderboard Row
    },
    second: {
        name: "red",
        main: "#995959",
        lightBG: "#FF9494",
        mediumBG: "#FF9494",
        darkBG: "#FF9494",
    },
    third: {
        name: "blue",
        main: "#466b97",
        lightBG: "#74B3FB",
        mediumBG: "#74B3FB",
        darkBG: "#74B3FB",
    },
    fourth: {
        name: "green",
        main: "#467a49",
        lightBG: "#75CC7A",
        mediumBG: "#75CC7A",
        darkBG: "#75CC7A",
    }
};
export var brandAtInnovate = {
    host: {
        create: {
            errorColor: "#F44336",
        },
        game: {
            pauseColor: "#F44336",
        },
    },
    welcome: {
        welcomeText: { color: sasBrandColor.lightBlue },
        subtitle: {
            color: sasBrandColor.lightBlue
        },
        footer: {
            color: brandAtInnovateColors.lightBlue,
        },
        instructions: {
            instructionBorder: "1px solid ".concat(sasBrandColor.lightBlue),
            circleColor: brandAtInnovateColors.yellow,
            teamNoIcon: true,
            small: {
                src: "/assets/instructions/brandAtInnovate/instructions-small.jpeg",
                countdown: {
                    label: {
                        top: -1,
                        left: 118,
                    },
                    text: {
                        top: 5,
                        left: 10
                    }
                },
                submit: {
                    label: {
                        top: 119,
                        left: 100
                    },
                    text: {
                        top: 132,
                        left: 10
                    }
                }
            },
            other: {
                countdown: {
                    label: {
                        top: 14,
                        left: 401,
                    },
                    text: {
                        top: 31,
                        left: 0,
                    }
                },
                submit: {
                    label: {
                        top: 225,
                        left: 243
                    },
                    text: {
                        top: 249,
                    }
                }
            },
            large: {
                src: "/assets/instructions/brandAtInnovate/instructions-large.jpeg",
                countdown: {
                    label: {
                        top: 14,
                        left: 229
                    },
                    text: {
                        top: 6,
                        left: 0,
                    }
                },
                submit: {
                    label: {
                        top: 124,
                        left: 135
                    },
                    text: {
                        top: 128,
                    }
                }
            },
        },
        actionButton: {
            border: "none",
            textTransform: "none",
            color: sasBrandColor.black,
            bgColor: brandAtInnovateColors.yellow,
            width: 120,
            lighten: true,
            fontWeight: 700,
        },
        textField: {
            bgColor: sasBrandColor.white,
            bgHoverColor: "#f4f4f6",
            textColor: sasBrandColor.black,
            labelColor: "#6C7689",
            errorColor: brandAtInnovateColors.yellow,
            width: 300,
        },
        gameCountdownColor: brandAtInnovateColors.lightYellow,
    },
    background: {
        backgroundImage: {
            large: (_a = {},
                _a[BackgroundType.Welcome] = "url('/assets/backgrounds/brandAtInnovate/bg-large-welcome.png')",
                _a[BackgroundType.GetStarted] = "url('/assets/backgrounds/brandAtInnovate/bg-large-welcome.png')",
                _a[BackgroundType.Main] = "linear-gradient(180deg, #5232E8 0%, #0767D4 100%)",
                _a[BackgroundType.ThankYou] = "url('/assets/backgrounds/brandAtInnovate/bg-large-thankyou.svg')",
                _a),
            small: (_b = {},
                _b[BackgroundType.Welcome] = "url('/assets/backgrounds/brandAtInnovate/bg-small-welcome.png')",
                _b[BackgroundType.GetStarted] = "url('/assets/backgrounds/brandAtInnovate/bg-small-welcome.png')",
                _b[BackgroundType.Main] = "linear-gradient(180deg, #5232E8 0%, #0767D4 100%)",
                _b[BackgroundType.ThankYou] = "url('/assets/backgrounds/brandAtInnovate/bg-small-thankyou.svg')",
                _b),
        },
        backgroundColor: (_c = {},
            _c[BackgroundType.Welcome] = sasBrandColor.sasBlue,
            _c[BackgroundType.GetStarted] = sasBrandColor.sasBlue,
            _c[BackgroundType.Main] = sasBrandColor.sasBlue,
            _c[BackgroundType.ThankYou] = sasBrandColor.sasBlue,
            _c)
    },
    gameComplete: {
        //Future theming note: with future themes, may need to consider fully theming decorative circles
        decorativeCircles: false,
        thankYouTextColor: "white",
        background: "linear-gradient(180deg, #5232E8 0%, #0767D4 100%)",
    },
    presenterVideo: {
        background: sasBrandColor.midnightBlue,
        muteBackground: sasBrandColor.lightBlue,
        textBackground: sasBrandColor.lightBlue,
        simpleDesign: true,
    },
    questionPrompt: {
        background: brandAtInnovateColors.darkAccent,
        timerColor: sasBrandColor.white,
        timeRemainderColor: brandAtInnovateColors.yellow,
        delayedColor: "#7F88F1",
    },
    questionExplanation: {
        //Using RGB to get opacity right
        backgroundColor: "rgb(4, 47, 99, 0.5)"
    },
    multipleChoice: {
        multipleChoiceColors: {
            first: "#0770E9",
            second: "#0770E9",
            third: "#0770E9",
            fourth: "#0770E9",
            disabled: "#446499"
        },
        feedbackColor: brandAtInnovateColors.lightBlue
    },
    phrase: {
        foregroundColor: "#C4DEFD",
        foregroundFocusColor: "#6C7689"
    },
    questionSubmit: {
        border: "none",
        borderRadius: 24,
        background: brandAtInnovateColors.yellow,
        icon: undefined,
        foreground: sasBrandColor.black,
        fontWeight: 700,
        matchInlineStyle: true,
    },
    questionProgress: {
        box: {
            color: brandAtInnovateColors.lightBlue
        },
        pastBox: {
            backgroundColor: brandAtInnovateColors.darkAccent,
            color: brandAtInnovateColors.chatLight,
        },
        currentBox: {
            backgroundColor: brandAtInnovateColors.yellow,
        }
    },
    chat: {
        inputBorder: "2px solid white",
        scrollBar: sasBrandColor.lightBlue,
        background: {
            focused: brandAtInnovateColors.darkAccent,
            unfocused: brandAtInnovateColors.darkAccent,
        },
        colorDark: brandAtInnovateColors.chatDark,
        colorLight: brandAtInnovateColors.chatLight,
        nicknameFontWeight: 700,
        sendButton: {
            icon: "/assets/icons/brandAtInnovate/chat-input.svg",
            background: sasBrandColor.white
        },
    },
    teamInfos: TeamInfos,
    accessoryPanel: {
        background: brandAtInnovateColors.darkAccent,
        textColor: brandAtInnovateColors.chatLight,
        expandButton: {
            largeButton: true,
            desktop: {
                chevron: {
                    src: "/assets/accessory/brandAtInnovate/expand-desktop.png",
                    srcSet: "/assets/accessory/brandAtInnovate/expand-desktop.png, /assets/accessory/brandAtInnovate/expand-desktop@2x.png 2x"
                },
                chevronWarning: {
                    src: "/assets/accessory/brandAtInnovate/expand-desktop-glow.png",
                    srcSet: "/assets/accessory/brandAtInnovate/expand-desktop-glow.png, /assets/accessory/brandAtInnovate/expand-desktop-glow@2x.png 2x"
                }
            },
            mobile: {
                expand: {
                    src: "/assets/accessory/brandAtInnovate/expand-mobile.png",
                    srcSet: "/assets/accessory/brandAtInnovate/expand-mobile.png, /assets/accessory/brandAtInnovate/expand-mobile@2x.png 2x"
                },
                expandGlow: {
                    src: "/assets/accessory/brandAtInnovate/expand-mobile-glow.png",
                    srcSet: "/assets/accessory/brandAtInnovate/expand-mobile-glow.png, /assets/accessory/brandAtInnovate/expand-mobile-glow@2x.png 2x"
                }
            }
        },
        tabs: {
            background: "#2D4DDE",
            mobileBackground: brandAtInnovateColors.darkAccent,
            tabSelector: "3px solid white",
            textColor: sasBrandColor.white,
            largeTabSize: true
        },
        participantCounter: "squares",
        leaderboard: {
            removeBackgroundSVG: true,
            teamAverage: {
                color: sasBrandColor.black
            },
            rankChange: {
                down: "#ff5c5c",
                up: "#63c568"
            },
            row: {
                borderWidth: 0,
                rankedStreakSVG: "/assets/leaderboard/brandAtInnovate/hot-streak.svg",
                unrankedStreakSVG: "/assets/leaderboard/brandAtInnovate/hot-streak.svg",
                leaderboardTiles: true,
                regularPlayer: {
                    rankedColor: sasBrandColor.white,
                    unrankedColor: sasBrandColor.white,
                    team: {
                        rankedColor: sasBrandColor.black,
                        unrankedColor: sasBrandColor.black,
                    },
                },
                currentPlayer: {
                    borderWidth: "2px 0 2px 2px",
                    borderColor: sasBrandColor.white,
                    unrankedColor: sasBrandColor.white,
                    rankedColor: sasBrandColor.white,
                    rankChangeUnrankedColor: sasBrandColor.white,
                    rankChangeRankedColor: sasBrandColor.white,
                    team: {
                        unrankedColor: sasBrandColor.black,
                        rankedColor: sasBrandColor.black,
                        rankChangeUnrankedColor: sasBrandColor.black,
                        borderColor: "#E2EEFF",
                        rankChangeRankedColor: sasBrandColor.black,
                    },
                },
            },
            scorePill: {
                showBorder: false
            },
            rank: {
                showBorder: false
            },
            firstPlace: {
                backgroundColor: "#5232E8",
                highlightColor: sasBrandColor.white,
                borderColor: sasBrandColor.white
            },
            secondPlace: {
                backgroundColor: "#2D4DDE",
                highlightColor: sasBrandColor.white,
                borderColor: sasBrandColor.white
            },
            thirdPlace: {
                backgroundColor: "#0767D4",
                highlightColor: sasBrandColor.white,
                borderColor: sasBrandColor.white
            },
            default: {
                borderColor: "none",
                backgroundColor: "#446499",
            }
        },
        dashBoard: {
            simpleDashboard: true,
            sectionTitleColor: "#C4DEFD",
            background: "#09214c",
            lineChart: {
                background: brandAtInnovateColors.dashboardBG,
                svgBackground: "transparent linear-gradient(179deg, ".concat(brandAtInnovateColors.dashboardBG, " 0%, ").concat(brandAtInnovateColors.dashboardBG, " 100%) 0% 0% no-repeat padding-box"),
                currentPlayer: {
                    color: sasBrandColor.mediumBlue
                },
                hoverPlayer: {
                    color: sasBrandColor.lightBlue
                }
            },
            maxCorrect: {
                background: brandAtInnovateColors.dashboardBG,
                highlightColor: "#FFCC33"
            },
            gauge: {
                background: brandAtInnovateColors.dashboardBG,
                gaugeSVGPath: "/assets/dashboard/brandAtInnovate/gauge.svg",
                needleSVGPath: "/assets/dashboard/brandAtInnovate/needle.svg"
            },
            streak: {
                fireSVGPath: "/assets/dashboard/brandAtInnovate/streak.svg",
                streakNumberColor: brandAtInnovateColors.dashboardBG
            },
            questionSummary: {
                background: brandAtInnovateColors.dashboardBG,
                correct: {
                    answeredTextColor: sasBrandColor.black,
                    backgroundColor: "#61A8FA"
                },
                incorrect: {
                    answeredTextColor: sasBrandColor.black,
                    backgroundColor: brandAtInnovateColors.yellow
                }
            },
            averageTime: {
                stopWatchSVGPath: "/assets/dashboard/brandAtInnovate/stopwatch.svg",
                host: {
                    timeColor: sasBrandColor.white,
                    background: brandAtInnovateColors.dashboardBG,
                },
                player: {
                    timeColor: sasBrandColor.white,
                    background: brandAtInnovateColors.dashboardBG,
                }
            }
        },
    },
    breakpoints: createBreakpoints({
        values: {
            xs: 0,
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1367,
            xxl: 2000,
            xxxl: 3000,
        }
    }),
    color: createColors(sasBrandColor.sasBlue, sasBrandColor.midnightBlue, "#E4E9EC", leaderboardColors.yellow),
};
//# sourceMappingURL=brandAtInnovate.js.map